import React, { useState } from 'react';
import Home from '../../pages/Home';
import DoctorsCarouselModal from './editor_modals/home_modals/DoctorsCarouselModal'; // Renamed
import HeroModal from './editor_modals/home_modals/HeroModal';
import AboutUsModal from './editor_modals/home_modals/AboutUsModal'; // Renamed
import ServicesModal from './editor_modals/home_modals/ServicesModal';
import HealthPackagesModal from './editor_modals/home_modals/HealthPackagesModal'; // Renamed
import TestimonialsModal from './editor_modals/home_modals/TestimonialsModal'; // Renamed
import HealthcareServicesGridModal from './editor_modals/home_modals/HealthcareServicesGridModal'; // Renamed


const HomeEditor = ({ getDivider, availableShapes }) => {
  const [isDoctorsCarouselOpen, setDoctorsCarouselOpen] = useState(false); // Renamed
  const [isHeroOpen, setHeroOpen] = useState(false);
  const [isAboutUsOpen, setAboutUsOpen] = useState(false); // Renamed
  const [isServicesOpen, setServicesOpen] = useState(false);
  const [isStatisticsOpen, setStatisticsOpen] = useState(false);
  const [isHealthPackagesOpen, setHealthPackagesOpen] = useState(false); // Renamed
  const [isTestimonialsOpen, setTestimonialsOpen] = useState(false); // Renamed
  const [isHealthcareServicesGridOpen, setHealthcareServicesGridOpen] = useState(false); // Renamed


  return (
    <div className='grid grid-cols-5 gap-40 items-start justify-between p-20 w-[1300px]'>
      {/* Buttons Section */}
      <div className='grid grid-cols-2 gap-28 font-bold text-center'>
        <button className="btn btn-primary w-20 m-2 p-2" onClick={() => setDoctorsCarouselOpen(true)}>Doctors Carousel</button> {/* Renamed */}
        <button className="btn btn-primary w-20 m-2" onClick={() => setHeroOpen(true)}>Hero</button>
        <button className="btn btn-primary w-20 m-2" onClick={() => setAboutUsOpen(true)}>About Us</button> {/* Renamed */}
        <button className="btn btn-primary w-20 m-2" onClick={() => setServicesOpen(true)}>Services</button>
        <button className="btn btn-primary w-20 m-2" onClick={() => setHealthPackagesOpen(true)}>Health Packages</button> {/* Renamed */}
        <button className="btn btn-primary w-20 m-2 px-12 " onClick={() => setTestimonialsOpen(true)}>Testimonials</button> {/* Renamed */}
        <button className="btn btn-primary w-20 m-2 px-12" onClick={() => setHealthcareServicesGridOpen(true)}>Healthcare Services Grid</button> {/* Renamed */}
      </div>


      {/* Mockup Browser Section */}
      <div className="col-span-4 mockup-browser bg-white border-8 border-black p-2 h-[1000px] overflow-y-scroll">
        <div>
          <div className="mockup-browser-toolbar m-10">
            <div className="input">https://sample-website.com</div>
          </div>
          <div className='overflow-scroll'>
            <Home context={{ getDivider, availableShapes }} />
          </div>
        </div>
      </div>


      {/* Modal Components */}
      <HeroModal isOpen={isHeroOpen} onClose={() => setHeroOpen(false)} />
      <AboutUsModal isOpen={isAboutUsOpen} onClose={() => setAboutUsOpen(false)} /> {/* Renamed */}
      <ServicesModal isOpen={isServicesOpen} onClose={() => setServicesOpen(false)} />
      <HealthPackagesModal isOpen={isHealthPackagesOpen} onClose={() => setHealthPackagesOpen(false)} /> {/* Renamed */}
      <TestimonialsModal isOpen={isTestimonialsOpen} onClose={() => setTestimonialsOpen(false)} /> {/* Renamed */}
      <HealthcareServicesGridModal isOpen={isHealthcareServicesGridOpen} onClose={() => setHealthcareServicesGridOpen(false)} /> {/* Renamed */}
      <DoctorsCarouselModal isOpen={isDoctorsCarouselOpen} onClose={() => setDoctorsCarouselOpen(false)} /> {/* Renamed */}
    </div>
  );
};

export default HomeEditor;
